import {BaseComponent} from './base-component.js';
import {customElement} from 'lit/decorators.js';
import {html, css} from 'lit';

@customElement('il-page-footer')
export default class PageFooterComponent extends BaseComponent {
  static override styles = [
    BaseComponent.styles,
    css`
      :host {
        width: 100%;
      }

      .il-page-footer-container {
        --il-page-footer-background-color: var(--il-color-neutrals-0);
        --il-page-footer-padding: 16px;

        padding: var(--il-page-footer-padding);
        background-color: var(--il-page-footer-background-color);
        width: 100%;
      }

      .il-page-footer {
        display: flex;

        align-items: center;
        justify-content: center;
      }
    `,
  ];

  override render() {
    return html`
      <div
        class="
          ${this.baseCSSClass}
          il-page-footer-container
        "
        data-test-iliad-page-footer-container
      >
        <div class="il-page-footer" data-test-iliad-page-footer>
          <slot></slot>
        </div>
      </div>
    `;
  }
}
